import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useId } from "react";
import { cn } from "../../../utils/index.js";
import { Collapsible } from "../../Collapsible/index.js";
import { Heading } from "../../Heading/index.js";
import { P } from "../../Text/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { deriveChildEmphasis, deriveEmphasisColors, isSplitDisplay } from "../Module.types.js";
import { moduleFAQVariants } from "./ModuleFAQ.variants.js";
const ModuleFAQ_ModuleFAQ = /*#__PURE__*/ forwardRef(function({ faqs: rawFaqs, variant = 'grid', maxColumns, children, ...sectionProps }, ref) {
    const instanceId = useId();
    const faqs = rawFaqs.slice(0, 9);
    const split = isSplitDisplay(sectionProps.display);
    const isAccordion = 'accordion' === variant;
    let autoColumns = 3;
    if (1 === faqs.length) autoColumns = 1;
    else if (2 === faqs.length) autoColumns = 2;
    const computedColumns = split ? Math.min(autoColumns, 2) : autoColumns;
    const limitedColumns = maxColumns ? Math.min(maxColumns, computedColumns) : computedColumns;
    const columns = isAccordion ? 1 : limitedColumns;
    const { gridWrapper, grid, faqItem } = moduleFAQVariants({
        variant,
        columns,
        display: sectionProps.display
    });
    const emphasis = deriveChildEmphasis(sectionProps.emphasis);
    const { headingPalette, headingShade, bodyColor } = deriveEmphasisColors(emphasis);
    const gridContent = /*#__PURE__*/ jsx("div", {
        className: gridWrapper(),
        children: /*#__PURE__*/ jsx("div", {
            className: grid(),
            children: faqs.map((faq)=>/*#__PURE__*/ jsxs("div", {
                    className: faqItem(),
                    children: [
                        /*#__PURE__*/ jsx(Heading, {
                            as: "h3",
                            palette: headingPalette,
                            shade: headingShade,
                            className: "text-heading5 @lg:text-heading4",
                            children: faq.heading
                        }),
                        /*#__PURE__*/ jsx(P, {
                            className: cn('text-body2 @lg:text-body1', bodyColor),
                            children: faq.body
                        })
                    ]
                }, faq.heading))
        })
    });
    const accordionContent = /*#__PURE__*/ jsx("div", {
        className: gridWrapper(),
        children: /*#__PURE__*/ jsx("div", {
            className: grid(),
            children: faqs.map((faq, i)=>/*#__PURE__*/ jsx(Collapsible, {
                    className: "w-full",
                    panelId: `module-faq-${instanceId}-${i}`,
                    flushAligned: true,
                    heading: /*#__PURE__*/ jsx(Heading, {
                        as: "h3",
                        palette: headingPalette,
                        shade: headingShade,
                        className: "text-heading5 @xl:text-heading4",
                        children: faq.heading
                    }),
                    children: /*#__PURE__*/ jsx(P, {
                        className: cn('text-body2 @xl:text-body1', bodyColor),
                        children: faq.body
                    })
                }, faq.heading))
        })
    });
    const defaultContent = isAccordion ? accordionContent : gridContent;
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        children: children ?? defaultContent
    });
});
export { ModuleFAQ_ModuleFAQ as ModuleFAQ };
